import { CourseInstructionType, DefaultNames } from "../components/course-author/types";

export function abbreviateComponentType(type?: CourseInstructionType) {
  return typeTitle(type)
    .toLowerCase()
    .split(" ")
    .slice(1, 2)
    .join("")
    .slice(0, 4);
}

export function typeTitle(type?: CourseInstructionType | null): string {
  switch (type) {
    case CourseInstructionType.Appendix:
      return DefaultNames.Appendix;
    case CourseInstructionType.Introduction:
      return DefaultNames.Introduction;
    case CourseInstructionType.Lesson:
      return DefaultNames.Lesson;
    case CourseInstructionType.Summary:
      return DefaultNames.Summary;
    default:
      return DefaultNames.Unit;
  }
}

export function instructionType(type?: CourseInstructionType): string {
  return typeTitle(type).slice(8);
}
